module.exports = "<div class=\"chromecast-playback\">\n  <div class=\"chromecast-playback-background\"></div>\n  <div class=\"chromecast-playback-overlay\"></div>\n</div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/plugins/chromecast/public/chromecast.html
 ** module id = 143
 ** module chunks = 0
 **/